<template>
  <div>
    <div class="jifen_num">
      <div class="now_jifen">
        <p class="fl">当前积分</p>
        <p class="jf_guide" @click="guideClick">
          <qdd-icon class="iconwenhao" color="#FD3E3E" size="0.6rem"></qdd-icon>积分规则
        </p>
      </div>
      <div class="jifen">{{ b_money }}</div>
    </div>

    <div class="jilu">
      <div class="jilu_nav" id="boxFixed" :class="{ fixed: isFixed }">
        <p v-for="(item, index) in tab" v-on:click="addClass(item.time_num, index)" v-bind:key="index"
          v-bind:class="{ active: index == current }">
          {{ item.text }}
        </p>
      </div>
      <ul class="cloumn_con">
        <li v-for="(item, index) in integralList" :key="index">
          <p>{{ item.typeName }}</p>
          <p class="time">{{ item.add_time }}</p>
          <span class="red">{{ item.zf_bjinbi }}</span>
          <!-- <span class="red" v-if="item.type == 50 || item.type == 42 || item.type == 209">+{{ item.zf_bjinbi }}</span> -->
        </li>
      </ul>
    </div>
    <!--积分记录弹框-->
    <div class="pop" v-if="isShowPop">
      <div class="pop_con">
        <h2>积分规则</h2>
        <p>1.发生售后，会扣除相应积分；</p>
        <p>2.积分不可折现金；</p>
        <p>3.商家享有部分解释权，如有疑问，请与 商家取得联系</p>
        <div class="sure" @click="sureClick">确定</div>
      </div>
    </div>

    <!--  无数据显示  -->
    <div class="null_data">
      <p v-if="!integralList.length && !showLoading" class="nodateimg">没有数据~</p>
      <p v-if="finished && integralList.length > 8">暂无更多数据~</p>
    </div>

    <mloading v-if="showLoading"></mloading>

  </div>
</template>

<script>
  import icon from '@/components/iconfont.vue'
  import { sendRequest } from '@/assets/public'
  import mloading from "@/components/loading.vue";

  export default {
    components: {
      'qdd-icon': icon,
      mloading
    },
    data() {
      return {
        current: 0,
        isShowPop: false, //是否显示弹框
        page: 1,
        time_num: 1,
        tab: [
          { text: '最近一年', id: 1, time_num: 1 },
          { text: '最近30天', id: 2, time_num: 2 },
          { text: '全部', id: 3 },
        ],
        integralList: [],
        finished: false, //列表是否加载完毕
        isFixed: false, //是否吸顶
        offsetTop: 0,
        b_money: 0,
        jifenCon: {},
        showLoading: false
      }
    },
    mounted() {
      this.b_money = this.$route.query.b_money // 当前积分记录
      this.integralInfoList()
      window.addEventListener('scroll', this.windowScroll)
      window.addEventListener('scroll', this.initHeight)
      this.$nextTick(() => {
        this.offsetTop = document.querySelector('#boxFixed').offsetTop
      })
    },
    methods: {
      initHeight() {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        this.isFixed = scrollTop > 100 ? true : false
      },

      windowScroll() {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop
        //变量windowHeight是可视区的高度
        var windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        //变量scrollHeight是滚动条的总高度
        var scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight
        //滚动条到底部的条件
        let that = this
        if (scrollTop + windowHeight == scrollHeight && this.page != 1) {
          setTimeout(function () {
            that.integralInfoList()
          }, 2000)
        }
      },
      async integralInfoList() {
        let that = this
        if (!this.finished && !this.showLoading) {
          this.showLoading = true
          let params = {
            page: that.page,
            limit: 15,
            time_num: that.time_num,
            store_id: localStorage.getItem('store_id'),
          }
          let res = await sendRequest('user/integralInfo', params)
          this.showLoading = false
          that.integralList = that.integralList.concat(...res.content.data)
          if (res.content.data.length < 15) {
            that.finished = true
          }
          that.page++
        }
      },

      addClass: function (time_num, index) {
        this.current = index
        this.page = 1
        this.time_num = time_num
        this.integralList = []
        this.finished = false
        this.integralInfoList()
      },
      guideClick() {
        this.isShowPop = true
      },
      sureClick() {
        this.isShowPop = false
      },
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    },
  }
</script>
<style scoped>
  .go_chacge {
    width: 2.8rem;
    height: 1.2rem;
    background: rgba(253, 62, 62, 1);
    border-radius: 0.2rem;
    float: right;
    font-size: 0.54rem;
    color: #fff;
    margin-right: 0.4rem;
    line-height: 1.2rem;
    text-align: center;
    margin-top: 0.4rem;
  }

  .jifen_show {
    width: 13.4rem;
    display: flex;
    overflow: hidden;
    justify-content: space-between;
    padding: 0.6rem 0.8rem;
  }

  .jifen_show span {
    display: block;
  }

  .jifen_show span b {
    display: block;
    color: #999999;
    font-weight: normal;
    font-size: 0.6rem;
    padding-bottom: 0.2rem;
  }

  .jifen_show span {
    text-align: center;
    color: #333;
    font-size: 0.62rem;
  }

  .null_data {
    text-align: center;
    font-size: 0.56rem;
    padding-top: 0.4rem;
  }

  .nodateimg {
    background: url('http://statics.7dingdong.com/static/wx_program_img/integral_mall/queshengye.png') no-repeat center center;
    background-size: 11.94rem 7.64rem;
    padding-top: 11.94rem;
  }

  .pop {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.5);
  }

  .pop .pop_con {
    position: fixed;
    top: 30%;
    left: 1.3rem;
    width: 12.4rem;
    background: #fff;
    border-radius: 0.2rem;
  }

  .pop_con h2 {
    font-size: 0.68rem;
    color: #333333;
    padding: 0.4rem 0;
    text-align: center;
    font-style: normal;
  }

  .pop_con p {
    color: #666666;
    font-size: 0.56rem;
    padding: 0 1.2rem;
    text-align: left;
    padding-bottom: 0.2rem;
  }

  .pop_con .sure {
    width: 12.4rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;

    color: #fd3e3e;
    font-size: 0.68rem;
    border-top: 1px solid #eee;
    margin-top: 0.3rem;
  }

  .jifen_num {
    width: 15rem;
    /*height: 3.84rem;*/
    background: #fff;
    border-bottom: 0.4rem solid #f0f0f0;
    overflow: hidden;
    border-top: 0.4rem solid #f0f0f0;
  }

  .now_jifen {
    padding: 0 0.8rem;
    overflow: hidden;
  }

  .now_jifen p {
    color: #333333;
    font-size: 0.6rem;
    padding-top: 0.8rem;
  }

  .jf_guide {
    color: #fd3e3e !important;
    font-size: 0.48rem;
    float: right;
  }

  .jifen {
    color: #333333;
    font-size: 1.2rem;
    font-weight: bolder;
    text-align: left;
    padding: 0.4rem 0.8rem;
    float: left;
  }

  .jilu {
    width: 15rem;
    position: relative;
    z-index: 9;
    background: #fff;
  }

  .jilu_nav {
    width: 15rem;
    height: 1.72rem;
    display: flex;
    justify-content: space-around;
  }

  .jilu_nav p {
    line-height: 1.72rem;
    font-size: 0.56rem;

    color: #333333;
  }

  .jilu_nav p.active {
    color: red;
  }

  .cloumn_con {
    padding: 0 0.8rem;
    overflow: hidden;
  }

  .cloumn_con li {
    border-top: 1px solid #eee;
    padding: 0.4rem 0;
    overflow: hidden;
    position: relative;
    /* height: 13rem; */
  }

  .cloumn_con li p {
    font-size: 0.56rem;
    color: #333333;
    padding: 0;
    text-align: left;
  }

  .cloumn_con li p.time {
    font-size: 0.48rem;
    color: #999999;
    padding: 0.2rem 0;
  }

  .cloumn_con li span {
    position: absolute;
    top: 0.8rem;
    right: 0;
    font-size: 0.72rem;
  }

  .cloumn_con li span.green {
    color: #15cb02;
  }

  .cloumn_con li span.red {
    color: #fd3e3e;
  }

  .fixed {
    position: fixed;
    top: 0;
    width: 100%;
    background: #fff;
    left: 0;
    /* box-sizing: border-box;
  padding: 0 40rpx; */
    z-index: 999;
    border-bottom: 1px solid #eee;
    box-shadow: 0 0 4px 4px #eee;
  }

  .line {
    width: 100%;
    height: 1.72rem;
    position: fixed;
    top: 0;
    z-index: 1;
    background: #000;
  }
</style>